import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentVerificationService, VerificationResult, VerificationState } from '../../../../services/payment-verification.service';
import { PurchaseFormService } from '../../../../services/purchase-form.service';

@Component({
  selector: 'app-payment-accept',
  templateUrl: './payment-accept.component.html',
  styleUrls: ['./payment-accept.component.css'],
  standalone: true,
  imports: [TranslateModule],
})
export class PaymentAcceptComponent implements OnInit {
  state: VerificationState = VerificationState.Verifying;
  protected readonly VerificationState = VerificationState;
  private orderId: string | null = null;

  constructor(
    private verificationService: PaymentVerificationService,
    private formService: PurchaseFormService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  async ngOnInit(): Promise<void> {
    const orderIdFromUrl = this.route.snapshot.paramMap.get('orderId');

    if (orderIdFromUrl) {
      sessionStorage.setItem('pendingOrderId', orderIdFromUrl);
    }

    const result = await this.verificationService.verifyPayment();
    this.handleResult(result);
  }

  async onRetry(): Promise<void> {
    this.state = VerificationState.Verifying;
    const result = await this.verificationService.retryVerification();
    this.handleResult(result);
  }

  async onDismiss(): Promise<void> {
    this.formService.restoreFormState();
    const specialTicketProductId = sessionStorage.getItem('pendingSpecialTicketProductId');
    await this.verificationService.cancelOrder();

    if (specialTicketProductId) {
      this.router.navigate(['/eventticket', specialTicketProductId]);
    } else {
      this.router.navigate(['/']);
    }
  }

  private handleResult(result: VerificationResult): void {
    this.orderId = result.orderId;
    this.state = result.state;

    if (this.state === VerificationState.Success) {
      this.formService.clearSavedFormState();
      setTimeout(() => this.router.navigate(['/orders', this.orderId]), 1500);
    }
  }
}
